// extracted by mini-css-extract-plugin
export default {"buttons":"index_buttons__cwsX9","hidden":"index_hidden__fqJYX","cancelButton":"index_cancelButton__A07on","formItem":"index_formItem__KL3Ct"};